/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import Media from 'react-media'

import styled from '@emotion/styled'


const StyledLi = styled('li')`
  color: ${({ theme }) => theme.secondary.medium};
  display: flex;
  align-items: center;
  padding: 0 24px;

  @media only screen and (min-width: 850px) and (max-width: 1200px) {
    padding-right: 400px;
  }

  @media only screen and (min-width: 850px) {
    padding-left: 32px;
  }

  svg {
    flex-shrink: 0;
  }
`

const StyledDiv = styled('div')`
  padding-left: 24px;
  flex: 1;

  @media only screen and (min-width: 850px) {
    padding-left: 48px;
  }
`

const StyledH3 = styled('h3')`
  color: ${({ theme }) => theme.secondary.base};
  font-family: ${({ theme }) => theme.fonts.bold};
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0;
`

const StyledP = styled('p')`
  color: ${({ theme }) => theme.text.medium};
  font-family: ${({ theme }) => theme.fonts.light};

  @media only screen and (min-width: 850px) {
    max-width: 500px;
  }
`

const ProductFeatureListItem = ({ children, Icon, title }) => (
  <StyledLi>
    <Media query= '(min-width: 850px)'>
      {match => <Icon size={match ? 80 : 64} />}
    </Media>
    <StyledDiv>
      <StyledH3>{title}</StyledH3>
      <StyledP>{children}</StyledP>
    </StyledDiv>
  </StyledLi>
)

ProductFeatureListItem.propTypes = {
  children: PropTypes.any.isRequired,
  Icon: PropTypes.func.isRequired,
  title: PropTypes.any.isRequired,
}

export default ProductFeatureListItem
